/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


module.exports = function ( app ) {
    var ts       = require('../ts')(app),
        gettext  = require('mag-gettext').gettext;

    return {
        id: 'timeShiftEnable',
        name: gettext('Enable TimeShift'),
        description: gettext('Enable TimeShift function.'),
        icon: 'theme-icon-timeshift',
        data: {
            timeShiftEnable: false
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            console.log(JSON.stringify(currentValue));
            callback(!!currentValue.timeShiftEnable);
        },
        prepareForSave: function ( value, callback ) {
            this.data.timeShiftEnable = value;

            ts.enable = value;
            callback();
        },
        render: app.api.renders.toggle,
        parent: 'timeshift'
    };
};
